import { PaymentMethodType } from 'types';
import { capitalize } from 'utils/string';
import { formatPrice } from 'utils/helpers';
import { EventCheckout } from 'store/api/event';

export const getPaymentMethodTypes = (data?: EventCheckout) => {
  const paymentMethodTypes = data?.paymentMethods?.map(
    (method) =>
      `${capitalize(method.type)} (${formatPrice(method.totalAmount)})`
  );

  const creditMethods = data?.paymentMethods?.filter(
    (method) => method.type === PaymentMethodType.Credit
  );

  return {
    paymentMethodTypes,
    isCredit: !!creditMethods?.length,
    creditMethods: data?.cloverPayments?.length
      ? data.cloverPayments
      : creditMethods,
  };
};
